var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrid = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 2h8v8H2zm10 0h8v8h-8zm10 0h8v8h-8zM2 12h8v8H2zm10 0h8v8h-8zm10 0h8v8h-8zM2 22h8v8H2zm10 0h8v8h-8zm10 0h8v8h-8z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrid);
export default ForwardRef;